<template>
  <div class="page-wrap wellcome-page">
    <div class="wrap clearfix">
      <ul class="type-list">
        <li class="linshou" @click="jumpTo('hsq')"></li>
        <li class="pifa" @click="jumpTo('jsz')"></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { commonParams,hsqAppid } from '@/libs/commonParamsStore.js'
const jumpUrlMap = {
  hsq: process.env.VUE_APP_LOGIN_HSQ_MAR,
  jsz: process.env.VUE_APP_LOGIN_JSZ_MAR,
}
export default {
  name: 'HsqWellcome',
  created() {
    commonParams.setDwdAppidAction(hsqAppid)
    commonParams.sys.logoMiniCls = ''
    commonParams.sys.logoText = '平台登录系统'
  },
  methods: {
    jumpTo(type) {
      if (typeof jumpUrlMap[type] != 'undefined') {
        this.$router.push({
          name: 'login',
          query: {
            subAppid: type,
            appId: hsqAppid,
            redirectUrl: jumpUrlMap[type]
          },
        })
      }
    },
  },
}
</script>

<style>
.type-list {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 240px;
}
.type-list li {
  width: 296px;
  height: 102px;
  background-position:center center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-size: contain;
}
.linshou {
  background: url('../assets/woshilingshou.png');
}
.pifa {
  background: url('../assets/woshipifa.png');
}
</style>
